/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_No_PaymentsInputs */

const en_settings_billing_no_payments = /** @type {(inputs: Settings_Billing_No_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payments yet`)
};

const zh_settings_billing_no_payments = /** @type {(inputs: Settings_Billing_No_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无付款记录`)
};

/**
* | output |
* | --- |
* | "No payments yet" |
*
* @param {Settings_Billing_No_PaymentsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_no_payments = /** @type {((inputs?: Settings_Billing_No_PaymentsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_No_PaymentsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_no_payments(inputs)
	return zh_settings_billing_no_payments(inputs)
});
export { settings_billing_no_payments as "settings.billing.no_payments" }